<template>
  <dd-modal
    :subtitle="subTitle"
    title="Add Comment"
    class="bulk-add-comment-modal"
    @handle-close="$emit('edit-canceled')"
  >
    <el-form label-position="top">
      <el-form-item label="Comment" prop="comment">
        <editor
          v-model="comment"
          fixed-height
          disable-toolbar-stickyness
        />
      </el-form-item>
    </el-form>
    <!-- FOOTER -->
    <template #footer>
      <span>
        <dd-button type="text" @click="$emit('edit-canceled')">Cancel</dd-button>
        <dd-button
          :is-disabled="disableSubmit"
          :is-loading="isSubmitting"
          :color="ColorAssistant.getEntityColor(entityType)"
          @click="handleUpdate"
        >Add comment</dd-button>
      </span>
    </template>
  </dd-modal>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import TextAssistant from '@/helpers/text-assistant'
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { EEntities } from '@/types'
import {
  IConvosInputBulkEditComment,
  ITasksInputBulkEditComment,
} from '@/api/types/request.types'

/* API */
import TasksAPI from '@/api/modules/tasks.api'
import ConversationsAPI from '@/api/modules/convos.api'

export default defineComponent({
  name: 'BulkAddCommentModal',
  props: {
    selectedItemIds: {
      type: Array as () => number[],
      default: (): number[] => [],
    },
    isConvoRelated: {
      type: Boolean,
      required: true,
    },
  },

  emits: ['edit-canceled', 'edit-completed'],
  data() {
    return {
      TextAssistant,
      ColorAssistant,
      EEntities,
      isSubmitting: false,
      comment: '',
    }
  },
  computed: {
    entityType(): EEntities {
      return this.isConvoRelated ? EEntities.MAILBOXES : EEntities.PROJECTS
    },
    subTitle(): string {
      return `Anyone assigned to these ${TextAssistant.itemPluralName(
        this.entityType,
      ).toLowerCase()} will be notified of your change.`
    },
    disableSubmit(): boolean {
      return (
        this.comment === '<p><br></p>' ||
        this.comment === null ||
        this.comment === ''
      )
    },
  },

  methods: {
    async handleUpdate() {
      this.isSubmitting = true
      let submitSucceeded = false

      if (this.isConvoRelated) {
        const data = {
          listConversationIDs: this.selectedItemIds,
          comment: this.comment,
        } as IConvosInputBulkEditComment
        try {
          const response = await ConversationsAPI.post_BulkEdit_Comment(data)
          this.$messaging.showSuccess(response.message)
          submitSucceeded = true
        } catch (error) {
          this.$error.emit(error, true)
        }
      } else {
        const data = {
          listTaskIDs: this.selectedItemIds,
          comment: this.comment,
        } as ITasksInputBulkEditComment
        try {
          const response = await TasksAPI.post_BulkEdit_Comment(data)
          this.$messaging.showSuccess(response.message)
          submitSucceeded = true
        } catch (error) {
          this.$error.emit(error, true)
        }
      }
      this.isSubmitting = false
      // Do update...
      if (submitSucceeded) {
        this.$emit('edit-completed')
      }
    },
  },
})
</script>

<style lang="scss">
</style>
